export default __webpack_public_path__ + "images/6c9d81950af24f5df9e318c2d7adfb9a-button_placement.svg";